import apiInstance from "../Api/ApiInstance";

export async function Coupons(coupon) {
  return await apiInstance.get(`api/nexus-main/coupons/${coupon}`);
}
